/* Site-Specific JavaScript */
var quoteSlider = jq('.quote-slider');
if (quoteSlider.length) {
    quoteSlider.slick({
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<div class="prev-arrow"><span class="sr-only">Prev</span></div>',
      nextArrow: '<div class="next-arrow"><span class="sr-only">Next</span></div>',
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        ]
    });    
}

jq('.audio-playlist-player').each(function() {
    var jsonFeedURL = jq(this).data('audio-playlist-feed-url');
    var tracks;
    var id_orig_diz;
    jq.ajax({
        type: "POST", 
        url: jsonFeedURL,
        dataType: "json", 
        async: false,
        success: function(data){
            tracks = data; //or something similar
        }
    });
    jq.each(tracks, function(i, track){
        console.log(track.name);
    });
});

// row-image-slider slick
jq('.row-image-slider').slick({
    arrows: true,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
});

// row-video-slider (slick)
jq('.video-swiper').slick({
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    swipe: false,
    prevArrow: jq('.prev-slide'),
    nextArrow: jq('.next-slide'),
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                swipe: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3,
                swipe: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
                swipe: true
            }
        }
    ]
});

